import React from 'react'
import { DatePicker } from 'antd'
import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs from 'dayjs'

const { RangePicker } = DatePicker

interface InputDateRangerFieldProps extends Partial<Omit<RangePickerProps, 'onChange' | 'value' | 'placeholder'>> {
  value?: [string, string] | string[]
  onChange?: (value: [string, string] | null) => void
  format?: string
  placeholder?: [string, string]
  isDisableFuture?: boolean
  minDate?: string
  maxDate?: string
}

const InputDateRangerField: React.FC<InputDateRangerFieldProps> = ({
  value,
  onChange,
  format = 'YYYY-MM-DD',
  placeholder = ['Start date', 'End date'],
  isDisableFuture = false,
  minDate,
  maxDate,
  ...props
}) => {
  const disabledDate = (current: any) => {
    if (!current) return false

    // Check if future dates should be disabled
    if (isDisableFuture && current > dayjs().endOf('month')) {
      return true
    }

    // Check if date is before minDate
    if (minDate && current < dayjs(minDate, format).startOf('day')) {
      return true
    }

    // Check if date is after maxDate
    if (maxDate && current > dayjs(maxDate, format).endOf('day')) {
      return true
    }

    return false
  }

  // Convert string array to dayjs array for RangePicker
  const getRangeValue = () => {
    if (!value) return null

    if (Array.isArray(value) && value.length === 2) {
      return [value[0] ? dayjs(value[0], format) : null, value[1] ? dayjs(value[1], format) : null]
    }

    return null
  }

  const handleChange = (dates: any) => {
    if (onChange) {
      if (dates && dates.length === 2 && dates[0] && dates[1]) {
        onChange([dates[0].format(format), dates[1].format(format)])
      } else {
        onChange(null)
      }
    }
  }

  return (
    <div className='xinput-date-custom'>
      <RangePicker
        value={getRangeValue()}
        onChange={handleChange}
        placeholder={placeholder}
        format={format}
        style={{ width: '100%', borderRadius: '20px', ...props.style }}
        className='h-[38px]'
        disabledDate={disabledDate}
        {...props}
      />
    </div>
  )
}

export default InputDateRangerField
